import React from 'react';
import ReferenceInput, { getChildrenProps } from './ReferenceInput';
import { AutocompleteInput } from 'react-admin';

const BillingGroupManagementCompanyInput = (props) => (
  <ReferenceInput gql={['id', 'name']} {...props}>
    <AutocompleteInput
      sx={{ width: 330 }}
      optionText={(o) => `${o.name} (${o?.id})`}
      {...getChildrenProps(props)}
    />
  </ReferenceInput>
);

BillingGroupManagementCompanyInput.defaultProps = {
  label: 'Billing Group Management Company',
  source: 'billing_group_management_company_id',
  reference: 'BillingGroupManagementCompany',
  sort: { field: 'id', order: 'ASC' },
  perPage: 25,
};

export default BillingGroupManagementCompanyInput;
